import { render, staticRenderFns } from "./rankingImg.vue?vue&type=template&id=dcd9d62c&scoped=true"
import script from "./rankingImg.vue?vue&type=script&lang=js"
export * from "./rankingImg.vue?vue&type=script&lang=js"
import style0 from "./rankingImg.vue?vue&type=style&index=0&id=dcd9d62c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd9d62c",
  null
  
)

export default component.exports